import { Chip } from "components/DesignSystem/Chips/Chips";

type NewChasersFilterChipProps = {
  isActive: boolean;
  onActivate: () => void;
  onDeactivate: () => void;
};

export const NewChasersFilterChip = ({
  isActive,
  onActivate,
  onDeactivate,
}: NewChasersFilterChipProps) => {
  const handleClick = () => {
    if (!isActive) {
      onActivate();
    }
  };

  return (
    <Chip
      isFixedFilter
      isActive={isActive}
      onRemove={onDeactivate}
      onClick={handleClick}
      size="regular"
    >
      New chasers
    </Chip>
  );
};
